﻿<div class="search-component">
    <div class="route-component">
        <div class="header">
            <h4>
                Client: {{client}}
            </h4>

            <button (click)="backToClientDetails()">
                <i class="fas fa-arrow-left"></i> Back To Client Details
            </button>
        </div>

         <h4 class="sub-header">
           Client Policy: {{clientArea}}
        </h4>

        <tab-control [activeTab]="activeTab">
            <!-- Details Tab -->
            <tab-page title="Policy Details" icon="fas fa-user-pen">
                <client-area-detail></client-area-detail>
            </tab-page>

            <!-- Endorsements Tab -->
            <tab-page *ngIf="policyId > 0" title="Endorsements" icon="fas fa-wallet">
                <client-area-endorsement-list></client-area-endorsement-list>
            </tab-page>

            <!-- Reports Tab -->
            <tab-page *ngIf="policyId > 0" title="Reports" icon="fas fa-table-list">
                <client-area-report-list></client-area-report-list>
            </tab-page>
        </tab-control>
    </div>
</div>